import _ from 'lodash';
import $ from 'jquery';

//Fires request to get time data everytime the window is in focus.
//Updates all clocks in the page (In the Header and in add comment feature)
let focused = false;

let subscribers = {};

export default {
    init() {
        $(document).bind('visibilitychange', () => {
            focused = !document.hidden;
            this.getTimeData();
        });

        focused = !document.hidden;
    },

    subscribe(fn) {
        let id = _.uniqueId();
        subscribers[id] = fn;

        return function() {
            delete subscribers[id];
        };
    },

    getTimeData() {
        if (!focused) return;

        $.ajax({
            url: '/track/user/time_booked',
            contentType: 'application/json; charset: utf-8',
            type: 'GET',
            success(response) {
                _.each(subscribers, (fn) => fn(response));

                let unallocatedMinutes = response.unallocated_minutes,
                    totalUnallocatedMinutes = response.total_unallocated_minutes,
                    personalMinutes = response.personal_minutes,
                    totalBooked = response.total_booked,
                    isDayStarted = !response.day_not_started,
                    dayBooked = response.day_booked,
                    clocks = window.clocks;

                //If time tracking is not necessary, return
                if (!clocks) return;
                //Updating all clocks
                if (clocks.commentUnallocated) {
                    //since last comment clock in add comment
                    clocks.commentUnallocated(unallocatedMinutes);
                }

                if (clocks.commentTotalUnallocated) {
                    //since start of day clock in add comment
                    clocks.commentTotalUnallocated(totalUnallocatedMinutes);
                }
                //since start of day clock in header, max 999
                if (isDayStarted) {
                    clocks.headerTotalUnallocated(Math.min(999, totalUnallocatedMinutes));
                }
                //personal minutes clock in header
                $('#personal-minutes').html(personalMinutes);
                $('#total-booked').html(totalBooked);
                $('#day-booked').html(dayBooked);
            }
        });
    }
};



/** WEBPACK FOOTER **
 ** ./js/app/common/time_data.js
 **/